import React, { useState, useEffect, useContext } from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import { Utils, UserContext } from "./../../common";
import axios from 'axios';
import DateWise from './DateWise';
import MySummary from './MySummary';
import TeamSummary from './TeamSummary';
import ChoosePlans from '../../components/application/ChoosePlans';

import Rota from '../users/Rota';
import AttnRequests from './AttnRequests';

const Attendence = (props) => {

    const [loading, setLoading] = useState(true);
    const { userData } = useContext(UserContext);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const [attn, setAttn] = useState({
        'attnLogDays': 30,
        'aid': 0,
        'datewise': [],
        'summary': {}
    });

    const loadAttendence = () => {
        axios.get(Utils.apiUrl('attendence/load'), Utils.apiHeaders())
            .then(res => {
                setLoading(false);
                const data = Utils.parseApiResponse(res);
                if (data.success) {
                    setAttn(data.data);
                }
            }).catch(err => {
                setLoading(false);
                console.log(err);
            });
    }

    useEffect(loadAttendence, []);
    if (!Utils.hasAccess(2)) {
        return (
            <>
                {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
                {userData.is_super_user && <>
                    <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
                    <ChoosePlans onPayment={() => { window.location.reload(); }} />
                </>}
            </>
        );
    }

    return (
        <div className="mt-sm-4">

            {loading && <Alert variant="info" className="p-3">
                <p className="loading-msg">Fetching attendence data</p>
                <ProgressBar variant="info" animated now={100} />
            </Alert>}
            {!loading && <>

                <DateWise
                    aid={attn.aid}
                    attnLogDays={attn.attnLogDays}
                    onMark={() => {
                        setRefreshTrigger(t => t + 1);
                        loadAttendence();
                    }}
                    onRefresh={() => {
                        setRefreshTrigger(t => t + 1);
                        loadAttendence();
                    }}
                    refreshTrigger={refreshTrigger}
                />

                <MySummary summary={attn.summary} refreshTrigger={refreshTrigger} />

                <TeamSummary refreshTrigger={refreshTrigger} />

                {userData.manager === true && <AttnRequests refreshTrigger={refreshTrigger} />}

                <Rota viewOnly={true} refreshTrigger={refreshTrigger} />
            </>}
        </div>
    )
}

export default Attendence;